<template>
  <div class="header">
    <template v-if="isPc">
      <!-- 导航栏（logo + 菜单） -->
      <div class="nav-bar">
        <div class="wrap">
          <div class="nav-inner">
            <img
              class="nav-logo"
              src="@/assets/header_logo.png"
              alt="鲁凝教育"
              @click="goHome"
            />
            <el-menu
              :default-active="activeMenu"
              mode="horizontal"
              class="nav-menu"
              @select="handleMenuSelect"
            >
              <el-menu-item
                v-for="item in navList"
                :key="item.path"
                :index="item.path"
              >
                {{ item.name }}
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </div>
    </template>

    <!-- 移动端 -->
    <template v-else>
      <nav class="mobile-navbar">
        <div class="mobile-nav-inner">
          <div class="mobile-brand" @click="goHome">鲁凝教育 · 二级建造师继续教育</div>
          <button class="mobile-toggler" @click="mobileMenuOpen = !mobileMenuOpen">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#1c4e8a" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
            </svg>
          </button>
        </div>
        <div v-if="mobileMenuOpen" class="mobile-menu">
          <div v-for="item in navList" :key="item.path" :class="['mobile-menu-item', { active: isActive(item) }]" @click="handleMobileNavClick(item)">
            {{ item.name }}
          </div>
          <template v-if="!isLOgin">
            <div class="mobile-menu-item" @click="goLogin">登录</div>
            <div class="mobile-menu-item" @click="goRegister">免费注册</div>
          </template>
          <template v-else>
            <div class="mobile-menu-item" @click="goProfile">个人中心</div>
            <div class="mobile-menu-item" @click="goLogout">退出登录</div>
          </template>
        </div>
      </nav>
    </template>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "project-header",
  data() {
    return {
      mobileMenuOpen: false,
      navList: [
        { name: "网站首页", path: "/" },
        { name: "我的课程", path: "/mySubject" },
        { name: "通知公告", path: "/noticeList" },
        { name: "个人中心", path: "/profile" },
      ],
    };
  },
  computed: {
    isLOgin: function () { return getToken(); },
    isPc: function () { return window.innerWidth > 768; },
    // el-menu 当前激活项：沿用 isActive 的匹配逻辑
    activeMenu: function () {
      const active = this.navList.find(item => this.isActive(item));
      return active ? active.path : this.$route.path;
    },
    ...mapGetters(["name", "realName"]),
  },
  watch: { "$route"() { this.mobileMenuOpen = false; } },
  methods: {
    isActive(item) {
      const path = item.path;
      if (path === "/") return this.$route.path === "/";
      // 多个 nav 指向同一 path 时，只激活第一个，除非当前 item 匹配 query
      const firstIndex = this.navList.findIndex(n => {
        if (n.path === "/") return this.$route.path === "/";
        return this.$route.path.indexOf(n.path) === 0;
      });
      const currentIndex = this.navList.indexOf(item);
      // 如果当前有 query 匹配
      if (item.query && this.$route.path === item.path) {
        const queryMatch = Object.keys(item.query).every(k => this.$route.query[k] === String(item.query[k]));
        return queryMatch;
      }
      // 如果是同一个 path 的第一个（无 query 的），且当前路由没有匹配某个有 query 的
      if (firstIndex === currentIndex) {
        const hasQueryMatch = this.navList.some(n => n.query && this.$route.path === n.path
          && Object.keys(n.query).every(k => this.$route.query[k] === String(n.query[k])));
        return !hasQueryMatch;
      }
      return false;
    },
    goHome() { this.$router.push({ path: "/" }); },
    goProfile() {
      let routeData = this.$router.resolve({ name: "profile" });
      window.open(routeData.href, "_blank");
    },
    goLogin() { this.$router.push({ name: "Login" }); },
    goRegister() {
      let routeData = this.$router.resolve({ name: "register" });
      window.open(routeData.href, "_blank");
    },
    goMySubject() { this.$router.push({ path: "/mySubject" }); },
    goAllSubject() {
      this.$router.push({ path: "/mySubject", query: { tab: "buy" } });
    },
    goLogout() {
      sessionStorage.removeItem("loginAnnouncementShown");
      localStorage.removeItem("loginAnnouncementShown");
      this.$store.dispatch("user/logout");
      this.$message.success("退出成功");
    },
    // el-menu 选中回调：index 即菜单 path
    handleMenuSelect(index) {
      const item = this.navList.find(i => i.path === index);
      if (item) this.handleNavClick(item);
    },
    handleNavClick(item) {
      if (item.path === "/profile") { this.goProfile(); return; }
      this.$router.push({ path: item.path, query: item.query || {} });
    },
    handleMobileNavClick(item) {
      this.handleNavClick(item);
      this.mobileMenuOpen = false;
    },
  },
};
</script>

<style scoped lang="scss">
// 顶部导航吸顶：随页面滚动时固定在顶部
.header {
  position: sticky;
  top: 0;
  z-index: 100;
}

// ====================== 主导航 ======================
.nav-bar {
  background: #1c4e8a;
  height: 64px;
}

.nav-inner {
  display: flex;
  align-items: center;
  height: 64px;

  .nav-logo {
    height: 40px;
    margin-right: 18px;
    cursor: pointer;
    flex-shrink: 0;
  }
}

// 顶部横向菜单：用 Element UI el-menu 复刻参考站的做法
.nav-bar .nav-menu {
  flex: 1;
  height: 64px;
  background: transparent;
  border-bottom: none;

  ::v-deep .el-menu-item {
    height: 64px;
    line-height: 64px;
    padding: 0 24px;
    font-size: 17px;
    color: rgba(255, 255, 255, 0.85);
    background: transparent;
    border-bottom: 2px solid transparent;
    transition: all 0.2s;

    &:hover,
    &:focus {
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
    }

    &.is-active {
      color: #fff;
      font-weight: 600;
      background: rgba(255, 255, 255, 0.12);
      border-bottom-color: #fff;
    }
  }
}

// ====================== 移动端 ======================
.mobile-navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.mobile-nav-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 52px;
}

.mobile-brand {
  font-size: 14px;
  font-weight: 600;
  color: #1c4e8a;
  cursor: pointer;
}

.mobile-toggler {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.mobile-menu {
  background: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 8px 0;

  .mobile-menu-item {
    padding: 12px 24px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    &.active { color: #1c4e8a; font-weight: 600; background: #f5f8fc; }
    &:active { background: #f0f4ff; }
    &.mobile-menu-register { color: #1c4e8a; font-weight: 500; }
    &.mobile-menu-logout { color: #e53935; }
  }
}

@media (max-width: 600px) {
  .mobile-brand { font-size: 12px; }
}
</style>
